import { Pagination } from "../../../../model/pagination";
import HttpClient from "../../../services/http-client";
import { IContractPagedResponse } from "../../../../model/scp/contract/response/contract-paged-response";
import { IContractPageRequest } from "../../../../model/scp/contract/request/contract-paged-request";
import { IFilePageRequest } from "../../../../model/scp/base/request/file-paged-request";
import { IFileResponse } from "../../../../model/scp/base/response/file-response";
import { IFileAddRequest } from "../../../../model/scp/base/request/file-add-request";
import { serialize } from "object-to-formdata";
import { IContractAddEditRequest } from "../../../../model/scp/contract/request/contract-add-edit-request";
import { IContractResponse } from "../../../../model/scp/contract/response/contract-response";
import { IAmendmentPageRequest } from "../../../../model/scp/contract/amendment/request/amendment-paged-request";
import { IAmendmentAddEditRequest } from "../../../../model/scp/contract/amendment/request/amendment-add-edit-request";
import { IAmendmentFilePageRequest } from "../../../../model/scp/contract/amendment/request/amendment-file-paged-request";
import { IAmendmentFileAddRequest } from "../../../../model/scp/contract/amendment/request/amendment-file-add-request";
import { IAmendmentPagedResponse } from "../../../../model/scp/contract/amendment/response/amendment-paged-response";
import { IAmendmentResponse } from "../../../../model/scp/contract/amendment/response/amendment-response";
import { IAmendmentFileResponse } from "../../../../model/scp/contract/amendment/response/amendment-file-response";

const defaultPath = 'Contract';

const listContract = async (params: IContractPageRequest): Promise<Pagination<IContractPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: params
    }).then((response) => Object.assign(new Pagination<IContractPagedResponse>(), response.data));
};

const listContractFiles = async (params: IFilePageRequest): Promise<Pagination<IFileResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${params.id}/Files`,
        params: { page: params.page, pageSize: params.pageSize }
    }).then((response) => Object.assign(new Pagination<IFileResponse>(), response.data));
};

const addContract = async (params: IContractAddEditRequest, files: IFileAddRequest[]) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });
    if (files !== null && files.length > 0) {
        var count = 0;
        files.forEach(element => {

            if (element.title !== null && element.title !== undefined) {
                formData.append('titles', element.title);
            }
            if (element.documentTypeId !== null && element.documentTypeId !== undefined) {
                formData.append('typeDocumentIds', element.documentTypeId.toString());
            }
            if (element.document !== null && element.document !== undefined) {
                formData.append('files', element.document);
            }
            count++;
        });

    }
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const addFileContract = async (params: IFileAddRequest) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${params.id}/Files`,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const updateContract = async (id: number, params: IContractAddEditRequest) => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params,
    });
}

const deleteFileContract = async (justification: string, id: number, number: number) => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}/Files/${number}`,
        params: { justification }
    });
}
const getContract = async (id: number): Promise<IContractResponse> => {

    return await HttpClient.executeRequest({

        method: 'get',
        url: `/${defaultPath}/${id}`,
    }).then((response) => Object.assign({} as IContractResponse, response.data));
};
const deleteContract = async (justification: string, id: number) => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`,
        params: { justification }
    });
}

// Amendment methods
const listContractAmendments = async (params: IAmendmentPageRequest): Promise<Pagination<IAmendmentPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${params.contractId}/Amendments`,
        params: { page: params.page, pageSize: params.pageSize }
    }).then((response) => Object.assign(new Pagination<IAmendmentPagedResponse>(), response.data));
};

const getContractAmendment = async (contractId: number, sequentialId: number): Promise<IAmendmentResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${contractId}/Amendments/${sequentialId}`,
    }).then((response) => Object.assign({} as IAmendmentResponse, response.data));
};

const addContractAmendment = async (contractId: number, params: IAmendmentAddEditRequest) => {
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${contractId}/Amendments`,
        data: params,
    });
};

const updateContractAmendment = async (contractId: number, sequentialId: number, params: IAmendmentAddEditRequest) => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${contractId}/Amendments/${sequentialId}`,
        data: params,
    });
};

// Amendment Files methods
const listAmendmentFiles = async (params: IAmendmentFilePageRequest): Promise<Pagination<IAmendmentFileResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${params.contractId}/Amendments/${params.amendmentId}/Files`,
        params: { page: params.page, pageSize: params.pageSize }
    }).then((response) => Object.assign(new Pagination<IAmendmentFileResponse>(), response.data));
};

const addAmendmentFile = async (params: IAmendmentFileAddRequest) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${params.contractId}/Amendments/${params.amendmentId}/Files`,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const deleteAmendmentFile = async (justification: string, contractId: number, amendmentId: number, documentId: number) => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${contractId}/Amendments/${amendmentId}/Files/${documentId}`,
        params: { justification }
    });
};

const ContractAppService = {
    listContract,
    listContractFiles,
    addFileContract,
    addContract,
    updateContract,
    deleteFileContract,
    deleteContract,
    getContract,
    listContractAmendments,
    getContractAmendment,
    addContractAmendment,
    updateContractAmendment,
    listAmendmentFiles,
    addAmendmentFile,
    deleteAmendmentFile
};

export default ContractAppService;